import React from "react";
import Board from "./Board";
import PopupContext from "../utils/PopupContext";
import {
  calculateWinner,
  who_win,
  calculate_position,
  Fibonacci,
} from "../utils/gameHelpers";

class Game extends React.Component {
  // Enable access to Popup context to trigger popups from this class component
  static contextType = PopupContext;

  constructor(props) {
    super(props);
    this.state = {
      history: [
        {
          squares: Array(64).fill(null),
          aIsNext: true,
          rowsFree: Array(8).fill(true),
          position: Array(8).fill(null),
        },
      ],
      score: [
        {
          squares: JSON.stringify(Array(64).fill(null)),
          win_a: 0,
        },
      ],
    };
  }

  handleClick(i) {
    const history = this.state.history;
    const current = history[history.length - 1];
    const squares = current.squares.slice();
    const rowsFree = current.rowsFree.slice();
    const aIsNext = current.aIsNext;
    const position = current.position.slice();

    if (!rowsFree[~~(i / 8)]) {
      return;
    }

    squares[i] = aIsNext ? "a" : "b";
    rowsFree[~~(i / 8)] = false;
    position[history.length - 1] = "abcdefgh"[i % 8] + (~~(i / 8) + 1);

    this.setState(
      {
        history: history.concat([
          {
            squares: squares,
            aIsNext: !aIsNext,
            rowsFree: rowsFree,
            position: position,
          },
        ]),
      },
      () => {
        const winnerText = calculateWinner(squares, rowsFree, !aIsNext);
        if (winnerText && winnerText.includes("GAME OVER")) {
          const lines = winnerText.split("\n").filter((l) => l.trim() !== "");
          const content = (
            <div>
              {lines.map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
          );

          // trigger a persistent popup until user closes it
          const { triggerPopup } = this.context;
          if (triggerPopup) {
            triggerPopup({ content, persistent: true, startText: "Close" });
          }
        }
      }
    );
  }

  handleRestart = () => {
    this.setState({ history: [this.state.history[0]] });
  };

  render() {
    const history = this.state.history;
    const current = history[history.length - 1];
    const score = this.state.score;
    const winner = calculateWinner(
      current.squares,
      current.rowsFree,
      current.aIsNext
    );

    let status;
    if (winner) {
      status = "STATUS\n " + winner;
    } else {
      status = "Next player : " + (current.aIsNext ? "a" : "b");
    }

    const fib = Fibonacci(11);

    return (
      <div className="game">
        <div className="game-board">
          <Board
            squares={current.squares}
            rowsFree={current.rowsFree}
            aIsNext={current.aIsNext}
            position={current.position}
            onClick={(i) => this.handleClick(i)}
          />
          <div className="notation grid-md">
            <div className="status">
              <ol>{"abcdefgh"}</ol>
            </div>
          </div>
          <div className="status grid-md">
            <h3 className="accent">
              {"Recording = "} {current.position.join(" ")}
            </h3>
            <button
              className="grid-sm btn btn--warning"
              type="button"
              onClick={this.handleRestart}
            >
              Restart
            </button>
          </div>
        </div>
        <div className="game-info" grid-md="true">
          <div className="status">
            <ol>{status}</ol>
            <ol className="">
              {"Fibonacci(11) = "} {fib}
            </ol>
            <ol className="">
              {JSON.stringify(
                who_win(current.squares, current.rowsFree, current.aIsNext)
              )}
            </ol>
            <ol className="">
              {calculate_position(
                score,
                current.squares,
                current.rowsFree,
                current.aIsNext
              )}
            </ol>
          </div>
        </div>
        <div className="game-info">
          <ol>{/* TODO */}</ol>
        </div>
      </div>
    );
  }
}

export default Game;
